export interface CustomClip {
  clipId: number;
  trackId: number;
  name: string;
  startMs: number;
  endMs: number;
  createdAt: string;
}

export const MAX_CLIP_DURATION_MS = 60_000;
export const MIN_CLIP_DURATION_MS = 1_000;
